import styled from '@emotion/styled';
import { Tooltip } from 'antd';
import { IconQRCode } from '../../Icon';
import { DownloadableQRCode } from './DownloadableQRCode';

interface Props {
  landingPage: string;
  iconColor?: string;
}

export const DownloadableQRCodePopover: React.FC<Props> = ({ landingPage, iconColor }) => {
  return (
    <Tooltip title={<DownloadableQRCode landingPage={landingPage} />}>
      <Icon color={iconColor} />
    </Tooltip>
  );
};

const Icon = styled(IconQRCode)`
  :hover {
    opacity: 0.8;
  }
`;
